// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__8nUaJ","card":"styles_card__2Bf2M","overlay":"styles_overlay__4XjSk","selected":"styles_selected__34X6T"};